<div class="app-foot">
    <div class="app-foot">
        <div class="app-foot-links">
            <span>
                <a *ngIf="!hideLink" href="{{href}}" target="_blank" class="app-foot-link" >FREQUENTLY ASKED QUESTIONS</a>
                <a *ngIf="hideLink" href=""  class="app-foot-link" ></a>
            </span>
        </div>
    </div>  
</div>
